import React, { useState } from "react";
import cx from "classnames";
import Image from "next/image";
import isString from "lodash/isString";
import helper from "@utils/helper";
import { useEffect } from "react";
import { useCallback } from "react";
import _ from "lodash";
const View = ({
  wrapperProps = {},
  aspectRatio,
  speed = -1,
  animated = true,
  children,
  alt = "amanaki-image",
  className,
  hasClose = false,
  objectFit = "cover",
  layout = "fill",
  scale = "1",
  sizes,
  ...props
}: any) => {
  const [src, setSrc] = useState(props.src);

  let wrapperAnimated = {},
    wrapImgAnimated = {};
  if (animated) {
    wrapperAnimated =
      speed === 0
        ? {}
        : {
            "data-scroll": true,
            "data-scroll-repeat": true,
          };
    wrapImgAnimated = {
      "data-scroll": true,
      "data-scroll-speed": speed,
    };
  }

  useEffect(() => {
    if (props && !props.src && isString(props.image)) {
      setSrc(props.image);
    }
  }, [props]);

  useEffect(() => {
    if (!helper.isExternal(props.src) && src !== props.src) {
      setSrc(props.src);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.src]);

  const onError = useCallback(() => {
    //if the mobile image's src doesn't already exist
    setSrc(props.src);
  }, [props.src]);
  if (_.isEmpty(src) || src === '#') return null;
  return (
    <div
      {...wrapperAnimated}
      {...wrapperProps}
      className={cx("relative overflow-hidden wrapper", wrapperProps.className)}
    >
      <div
        {...wrapImgAnimated}
        className={cx("ama-img", wrapperProps.className)}
        style={layout === "fill" ? { position: "relative" } : {}}
      >
        <Image
          className={cx(className)}
          style={{
            aspectRatio,
            objectFit,
            ...(scale ? { transform: `scale(${scale})` } : {}),
          }}
          alt={alt}
          preload="true"
          fill={layout === "fill"}
          // loader={customLoader}
          onError={onError}
          {...props}
          src={src}
          sizes={
            layout === "fill" 
              ? (sizes || "100vw")
              : sizes
          }
        />
      </div>
    </div>
  );
};
export default View;
